import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { RootState, RootDispatch } from "../../types";
import VideoChat from "../components/VideoChat";
import ConsentComponent from "../components/ConsentComponent";
import { Patient } from "../../patient/types";
import { fetchConsentMessage } from "../actions";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import PendoDataProvider from "../../../components/PendoDataProvider";

interface StoreProps {
  currentUser: User | null;
  loading: boolean;
  patient: Patient | null;
  consentMessage?: string;
  consentAcknowledged: boolean;
}
interface DispatchProps {
  fetchConsentMessage: typeof fetchConsentMessage;
}

interface OwnState {
  isBusy: boolean;
}

type Props = OwnState &
  DispatchProps &
  StoreProps &
  RouteComponentProps<{ participantUid: string }>;

class VideoChatContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false
    };
  }
  public componentDidMount() {
    this.props.fetchConsentMessage(this.props.match.params.participantUid);
  }

  private renderComponent() {
    const { patient, consentMessage, loading, consentAcknowledged } = this.props;
    if (loading) {
      return <LoadingFullScreen />;
    }
    if (consentMessage && consentMessage.length > 0 && consentAcknowledged === false) {
      return <ConsentComponent consentMessage={consentMessage} />;
    }
    return <VideoChat patient={patient} participantId={this.props.match.params.participantUid} />;
  }

  public render() {
    const { currentUser } = this.props;

    const pendoDataProviderProps = {
      isAnonymous: currentUser ? false : true
    };

    return (
      <>
        <PendoDataProvider {...pendoDataProviderProps} />
        {this.renderComponent()}
      </>
    );
  }
}

export default connect(
  (state: RootState): StoreProps => ({
    loading: state.videochat.loading,
    patient: state.patientdetail.data.patient,
    consentMessage: state.videochat.data.consentMessage,
    consentAcknowledged: state.videochat.data.consentAcknowledged,
    currentUser: state.session.data.currentUser
  }),
  (dispatch: RootDispatch): DispatchProps => ({
    fetchConsentMessage: (participantUid: string) => dispatch(fetchConsentMessage(participantUid))
  })
)(VideoChatContainer);
